<template>
    <div class="chat-room-list">
        <div class="chat-section">
            <div class="chat-section-header">
                <span>Kanały</span>
                <a href="#" @click.prevent="openCreateRoom" title="Nowy pokój">
                    <i class="material-icons md-18">add</i>
                </a>
            </div>
            <div v-for="room in channels" :key="room._id" class="chat-room-item" @click="ChatManager.openRoom(room._id)">
                <div class="chat-room-icon"><i class="material-icons md-18">{{ room.type == 'general' ? 'tag' : 'group' }}</i></div>
                <div class="chat-room-info">
                    <div class="chat-room-name">{{ ChatManager.getRoomDisplayName(room) }}</div>
                    <div class="chat-room-preview" v-if="room.lastMessage && room.lastMessage.text">
                        {{ room.lastMessage.authorName }}: {{ ChatManager.renderPlainText(room.lastMessage.text) }}
                    </div>
                </div>
                <div class="chat-room-meta">
                    <div class="chat-room-time" v-if="room.lastMessageAt">{{ room.lastMessageAt | moment("from", "now") }}</div>
                    <span class="label rounded label-sm blue" v-if="room.unreadCount">{{ room.unreadCount >= 100 ? '99+' : room.unreadCount }}</span>
                </div>
            </div>
        </div>

        <div class="chat-section">
            <div class="chat-section-header"><span>Wiadomości bezpośrednie</span></div>
            <div v-for="room in dms" :key="room._id" class="chat-room-item" @click="ChatManager.openRoom(room._id)">
                <div class="chat-room-icon"><i class="material-icons md-18">person</i></div>
                <div class="chat-room-info">
                    <div class="chat-room-name">{{ ChatManager.getRoomDisplayName(room) }}</div>
                    <div class="chat-room-preview" v-if="room.lastMessage && room.lastMessage.text">
                        {{ ChatManager.renderPlainText(room.lastMessage.text) }}
                    </div>
                </div>
                <div class="chat-room-meta">
                    <div class="chat-room-time" v-if="room.lastMessageAt">{{ room.lastMessageAt | moment("from", "now") }}</div>
                    <span class="label rounded label-sm blue" v-if="room.unreadCount">{{ room.unreadCount >= 100 ? '99+' : room.unreadCount }}</span>
                </div>
            </div>

            <div class="chat-section-subheader">Rozpocznij rozmowę</div>
            <div v-for="user in usersWithoutDm" :key="user._id" class="chat-room-item chat-room-item-user" @click="startDm(user)">
                <div class="chat-room-icon"><i class="material-icons md-18">person_outline</i></div>
                <div class="chat-room-info">
                    <div class="chat-room-name">{{ user.name }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ChatManager from '../../ChatManager.js';
import SystemUsersManager from '../../SystemUsersManager.js';
import ChatCreateRoomModal from './ChatCreateRoomModal.vue';

export default {
    name: 'ChatRoomList',
    data: function() {
        return {
            ChatManager,
            state: ChatManager.state,
            systemUsers: [],
        };
    },
    created: async function() {
        this.systemUsers = await SystemUsersManager.getSystemUsers();
    },
    computed: {
        channels: function() {
            return this.state.rooms.filter(r => r.type == 'general' || r.type == 'group');
        },
        dms: function() {
            return this.state.rooms.filter(r => r.type == 'dm');
        },
        usersWithoutDm: function() {
            const me = String(ChatManager.getMyUserId());
            const withDm = new Set();
            this.dms.forEach(room => (room.members || []).forEach(m => withDm.add(String(m.userId))));
            return (this.systemUsers || [])
                .filter(u => String(u._id) != me && !u.isRemoved && !u.isDisabled && !withDm.has(String(u._id)))
                .sort((a, b) => (a.name || '').localeCompare(b.name || ''));
        }
    },
    methods: {
        startDm: async function(user) {
            try {
                await ChatManager.openDm(user._id);
            } catch (e) {
                this.$h.commonApiError(e);
            }
        },
        openCreateRoom: function() {
            this.$modal.show(ChatCreateRoomModal, {}, {
                draggable: false,
                clickToClose: true,
                height: 'auto',
                width: '400px'
            });
        }
    }
};
</script>

<style scoped lang="scss">
.chat-room-list {
    padding: 8px 0;
}

.chat-section {
    margin-bottom: 12px;
}

.chat-section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 14px;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    opacity: 0.6;

    a { color: inherit; display: flex; }
}

.chat-section-subheader {
    padding: 8px 14px 2px;
    font-size: 11px;
    opacity: 0.5;
}

.chat-room-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 14px;
    cursor: pointer;

    &:hover { background: var(--dm-surface-2, #f5f6f8); }
}

.chat-room-item-user { opacity: 0.8; }

.chat-room-icon {
    display: flex;
    align-items: center;
    opacity: 0.6;
    flex-shrink: 0;
}

.chat-room-info {
    flex: 1;
    min-width: 0;
}

.chat-room-name {
    font-weight: 500;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.chat-room-preview {
    font-size: 12px;
    opacity: 0.6;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.chat-room-meta {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 3px;
    flex-shrink: 0;
}

.chat-room-time {
    font-size: 10px;
    opacity: 0.5;
}
</style>
